var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { resolveVersionRef } from "@hyper-hyper-space/hhs3_rdb_runtime";
import { formatDelta } from "../format/delta.js";
export function runDeltaCommand(session, args) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        const [kind, name, startText, endText, strategyText] = args;
        if ((kind !== 'schema' && kind !== 'group') || name === undefined || startText === undefined || endText === undefined) {
            throw new Error('Usage: \\delta schema|group <name> <start> <end> [bounded|full]');
        }
        if (strategyText !== undefined && strategyText !== 'bounded' && strategyText !== 'full') {
            throw new Error(`Unknown delta strategy '${strategyText}' (expected bounded|full)`);
        }
        if (kind === 'schema' && strategyText !== undefined) {
            throw new Error('Delta strategy applies to groups only (bounded|full)');
        }
        const ctx = { aliases: session.aliases };
        if (kind === 'schema') {
            const resolved = yield session.workspace.roots.resolveSchema(ref(name), ctx);
            if (resolved.schema === undefined)
                throw new Error('Schema is not loaded');
            return formatDelta(session, {
                kind,
                name: (_b = (_a = session.workspace.roots.get(resolved.id)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : name,
                objectId: resolved.id,
                delta: yield resolved.schema.computeDelta(yield resolveVersionRef(session, startText, resolved.id), yield resolveVersionRef(session, endText, resolved.id)),
            });
        }
        const resolved = yield session.workspace.roots.resolveGroup(ref(name), ctx);
        if (resolved.group === undefined)
            throw new Error('Group is not loaded');
        const group = resolved.group;
        if (strategyText !== undefined)
            group.setDeltaStrategy(strategyText);
        const delta = yield group.computeDelta(yield resolveVersionRef(session, startText, resolved.id), yield resolveVersionRef(session, endText, resolved.id));
        const tableIdToName = new Map();
        const view = yield group.getView();
        for (const tableName of view.getTableNames()) {
            tableIdToName.set((yield group.getTable(tableName)).getId(), tableName);
        }
        return formatDelta(session, {
            kind,
            name: (_d = (_c = session.workspace.roots.get(resolved.id)) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : name,
            objectId: resolved.id,
            delta,
            tableIdToName,
        });
    });
}
function ref(text) {
    const span = { start: 0, end: text.length, line: 1, column: 1 };
    return text.startsWith('#')
        ? { kind: 'hash', prefix: text.slice(1), span }
        : { kind: 'name', text, parts: text.split('.'), span };
}
